<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <!-- <custom-input POR SI SE DESEA INCLUIR UN CAMPO DE BUSQUEDA GENERAL
        v-model="swageFilters.Busqueda"
        :label="'Búsqueda general'"
        :spanColumn="6"
        :settings="{
          placeholder:
            'Buscar por código, código adicional, descripción u observaciones (mín. 3 caracteres)',
        }"
      ></custom-input> -->
      <custom-input
        v-model="swageFilters.CodigoSuaje"
        :label="'Código'"
        :spanColumn="6"
        :settings="{
          placeholder: 'Mínimo 3 caracteres',
        }"
      ></custom-input>
      <custom-input
        v-model="swageFilters.Observaciones"
        :label="'Observaciones'"
        :spanColumn="6"
        :settings="{
          placeholder: 'Mínimo 3 caracteres',
        }"
      ></custom-input>

      <custom-select
        v-model="swageFilters.CodigoSuajeTipo"
        :label="'Tipo suaje'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Seleccionar tipo de suaje',
          options: claseSuaje,
        }"
      ></custom-select>

      <el-col
        :span="3"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrarSuaje"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
    <el-row
      :gutter="24"
      class="margin-row"
    >
      <custom-input
        v-model="swageFilters.CodigoAdicional"
        :label="'Código adicional'"
        :spanColumn="6"
        :settings="{
          placeholder: 'Mínimo 3 caracteres',
        }"
      ></custom-input>
      <custom-input
        v-model="swageFilters.Descripcion"
        :label="'Descripción'"
        :spanColumn="6"
        :settings="{
          placeholder: 'Mínimo 3 caracteres',
        }"
      ></custom-input>
      <el-col :span="4">
        <div class="custom-label">Activo</div>
        <el-switch
          v-model="swageFilters.Activo"
          active-text="Si"
          inactive-text="No"
          class="mb-2"
          sieze="large"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import CustomInput from '@/shared/components/custom_input.vue';
import { storeToRefs } from 'pinia';
import { useSwageStore } from '@/stores/swage_store.js';
import CustomSelect from '@/shared/components/custom_select.vue';
import IconDelete from '~icons/mdi/delete';
const swageStore = useSwageStore();
const { swageFilters, claseSuaje } = storeToRefs(swageStore);
const { emptyList, findAllSuajesHTTP, setPage, resetFilter } = swageStore;

const filtrarSuaje = () => {
  setPage(1);
  emptyList();
  findAllSuajesHTTP();
};
const LimpiarFiltros = () => {
  setPage(1);
  emptyList();
  resetFilter();
  findAllSuajesHTTP();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
